export const TENANT_USERS_ENDPOINT = 'api/v1/users';
